<template>
  <div class="container">
    <el-tabs v-model="activeName" class="tab-container">
      <el-tab-pane label="关联箱子" name="addBox"></el-tab-pane>
      <el-tab-pane label="扫描快递单" name="send"></el-tab-pane>
    </el-tabs>
    <AssociatedBox v-if="activeName === 'addBox'"/>
    <ScanningExpress v-if="activeName === 'send'"/>
  </div>
</template>

<script>
import AssociatedBox from './components/AssociatedBox';
import ScanningExpress from './components/ScanningExpress';

export default {
  name: 'AppDeliver',
  components: {
    AssociatedBox,
    ScanningExpress,
  },
  data() {
    return {
      activeName: 'addBox',
    };
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
  }
  .tab-container {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    flex-direction: column;
  }
</style>
